var $ = require('../../modules/$');
module.exports = function defineProperty(it, key, desc){
  return $.setDesc(it, key, desc);
};


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/~/core-js/library/fn/object/define-property.js
 ** module id = 443
 ** module chunks = 0 1 2 3 10 11 12 14 19 20
 **/